import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Products.css';
import './Reports.css';

const Reports = () => {
  const { isAdmin } = useAuth();

  return (
    <div className="page-container">
      <div className="container">
        <div className="page-header">
          <h1>Reports</h1>
        </div>
        <p className="reports-intro">Choose a report to open.</p>
        <div className="reports-grid">
          <Link to="/reports/customers" className="reports-card">
            <span className="reports-card-icon">📒</span>
            <strong>Customer Report</strong>
            <span>Sales, payments, and outstanding balances by customer.</span>
          </Link>
          <Link to="/reports/gst" className="reports-card">
            <span className="reports-card-icon">🧾</span>
            <strong>GST Report</strong>
            <span>GSTR-1 style list of invoices created with GST on.</span>
          </Link>
          {isAdmin && (
            <Link to="/reports/suppliers" className="reports-card">
              <span className="reports-card-icon">📗</span>
              <strong>Supplier Report</strong>
              <span>Purchases, payments, and supplier balances.</span>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default Reports;
